import React from 'react';

import './app-banner.css';


const AppBanner = () => {
    return (
        <div>   
            <div className="banner right"/>
            <div className="banner left"/>
        </div>
    )
}

export default AppBanner;